import {RouteSelectorProps, routesSelector, useGetAllRoutesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRouteMultiSelect, BaseRouteMultiSelectProps} from "./BaseRouteMultiSelect";

export type RouteMultiSelectProps = Omit<BaseRouteMultiSelectProps, "entities" | "loading"> & {
    selector?: RouteSelectorProps
}

export const RouteMultiSelect = (props: RouteMultiSelectProps) => {
    const {selector, ...rest} = props;

    const selectRoutes = useMemo(() => {
        return routesSelector();
    }, []);

    const {routes, isLoading} = useGetAllRoutesQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            routes: selectRoutes(result, selector),
            isLoading: result.isLoading
        })
    });

    return <BaseRouteMultiSelect entities={routes} loading={isLoading} {...rest} />;
};
